import { ShieldAlert } from "lucide-react";
import { Logo } from "@/components/logo";
import { Button } from "@/components/ui/button";
import { logout } from "@/lib/auth";
import { PROBLEMS } from "@/lib/accountStatus";

// Boot and account problems. Never redirects by itself, so it cannot loop.
export function SignInProblem({ kind }: { kind: string }) {
  const problem = PROBLEMS[kind] ?? PROBLEMS.failed;
  const tryAgain = () => window.location.replace("/");
  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-6">
      <div className="w-full max-w-sm text-center">
        <Logo size={44} className="mx-auto rounded-[10px] shadow-medium" />
        <h1 className="mt-4 flex items-center justify-center gap-2 text-lg font-semibold text-foreground">
          <ShieldAlert size={18} />
          {problem.title}
        </h1>
        <p className="mt-2 text-sm text-muted-foreground">{problem.message}</p>
        <div className="mt-6 flex justify-center gap-3">
          {problem.signOut && (
            <Button type="button" variant="outline" onClick={() => void logout().catch(tryAgain)}>
              Sign out
            </Button>
          )}
          <Button type="button" onClick={tryAgain}>
            Try again
          </Button>
        </div>
      </div>
    </div>
  );
}
